import React, { useState, useEffect, useContext } from "react";
import { useSnackbar } from "material-ui-snackbar-provider";
import domtoimage from "dom-to-image-more";
import { Link, useParams, useNavigate, useLocation } from "react-router-dom";
import Loader from "../../components/Spinner";
import "react-toastify/dist/ReactToastify.css";
import backicon from "../../assets/img/back.png";
import useTranslator from "../../hooks/useTranslator";
import LandLordContext from "../../context/landlord/LandLordContext";
import { haveValue } from "../../helper/common";
import GeneratedReportComponent from "../../components/Landlord/GeneratedReportComponent";
import AuthContext from "../../context/auth/AuthContext";
import axiosInstance from "../../services/authWrapper";
import { toast } from "react-toastify";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const GeneratedReport = () => {
  const queryParameters = new URLSearchParams(window.location.search);
  const llCreated = queryParameters.get("llCreated") === "true";
  const definedRent = queryParameters.get("rent") ?? 0;

  const sharedprofileid = queryParameters.get("sharedprofileid");
  const agencylink = queryParameters.get("agencylink");
  const { id } = useParams();
  const { _t } = useTranslator();

  const landLordContext = useContext(LandLordContext);
  const { properties, fetchingCreatedTenant } = landLordContext;
  const {
    checkIeDetails,
    user: originalUser,
    loadUser,
  } = useContext(AuthContext);

  const [user, setUser] = useState(null);
  const [currentActiveAccordion, setCurrentActiveAccordion] = useState("");
  const [loading, setLoading] = useState(false);
  const [rentPercentage, setRentPercentage] = useState(1);
  const [fullInfo, setFullInfo] = useState({});

  useEffect(() => {
    let usertype = localStorage.getItem("usertype");
    loadUser(usertype);
  }, []);

  useEffect(() => {
    if (llCreated) {
      fetchingCreatedTenant(id)
        .then((res) => {
          setLoading(false);
          setUser(res.data);
          setFullInfo(res.data);
        })
        .catch((err) => {
          setLoading(false);
          console.log(err, "Error inside fetchingCreatedTenant");
        });
    } else if (haveValue(sharedprofileid)) {
      axiosInstance
        .get(
          `${
            process.env.REACT_APP_SERVER_URL
          }/shared-profile/singleshared/${sharedprofileid}?landlordId=${localStorage.getItem(
            "saveduserid"
          )}`,
          { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
        )
        .then((res) => {
          let server_res = res;

          if (server_res.data.singleSharedProfile?.tenantid?.ie_details_id) {
            server_res.data.singleSharedProfile.tenantid.ie_verified =
              checkIeDetails(server_res.data.singleSharedProfile?.tenantid);
          }

          setFullInfo(server_res.data.singleSharedProfile);
          setUser(server_res.data.singleSharedProfile);
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
          toast.error(err.message);
        });
    } else if (haveValue(agencylink)) {
      axiosInstance
        .get(
          `${
            process.env.REACT_APP_SERVER_URL
          }/shared-profile/agency-shared/${agencylink}?landlordId=${localStorage.getItem(
            "saveduserid"
          )}`,
          { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
        )
        .then((res) => {
          let server_res = res;

          if (server_res.data.singleSharedProfile?.tenantid?.ie_details_id) {
            server_res.data.singleSharedProfile.tenantid.ie_verified =
              checkIeDetails(server_res.data.singleSharedProfile?.tenantid);
          }
          setFullInfo(server_res.data.singleSharedProfile);
          setUser(server_res.data.singleSharedProfile);
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
          toast.error(err.message);
        });
    } else {
      setUser(originalUser);
    }
  }, [originalUser]);

  const printDocument = () => {
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari) {
      printDocumentSafari();
    } else {
      printDocumentSafari();
    }
  };

  const printDocumentOthers1 = () => {
    var node = document.getElementById("divToPrint");
    // const documentEle = document.getElementById("downloadpdf");
    // if (haveValue(documentEle))
    //   documentEle.style.setProperty("display", "none", "important");
    domtoimage
      .toJpeg(node)
      // .toPng(node)
      .then(function (dataUrl) {
        console.log("dataUrl -> ", dataUrl);
        const pdf = new jsPDF("p", "mm", "a4");
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        const contentWidth = node.offsetWidth;
        const contentHeight = node.offsetHeight;
        // Calculate scale factors for width and height
        const scaleFactorWidth = pdfWidth / contentWidth;
        const scaleFactorHeight = pdfHeight / contentHeight;
        // Choose the smaller scale factor to fit content within A4 size
        const scaleFactor = Math.min(scaleFactorWidth, scaleFactorHeight);
        // Calculate image dimensions
        const imgWidth = contentWidth * scaleFactor;
        const imgHeight = contentHeight * scaleFactor;
        pdf.addImage(dataUrl, "PNG", 0, 0, imgWidth, imgHeight);
        pdf.save("SkorProfile.pdf");
        // if (documentEle) {
        //   documentEle.style.removeProperty("display");
        // }
      })
      .catch(function (error) {
        console.error("Oops, something went wrong!", error);
        // if (documentEle) {
        //   documentEle.style.removeProperty("display");
        // }
      });
  };

  const printDocumentOthers = async () => {
    const node = document.getElementById("divToPrint");
    // const documentEle = document.getElementById("downloadpdf");

    // if (documentEle)
    //   documentEle.style.setProperty("display", "none", "important");
    console.log();
    try {
      // document.querySelector(
      //   ".CircularProgressbar .CircularProgressbar-path"
      // ).classList = "changeClass";

      const canvas = await html2canvas(node, { useCORS: true });
      const dataUrl = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const contentWidth = canvas.width;
      const contentHeight = canvas.height;

      // Calculate scale factors for width and height
      const scaleFactorWidth = pdfWidth / contentWidth;
      const scaleFactorHeight = pdfHeight / contentHeight;

      // Choose the smaller scale factor to fit content within A4 size
      const scaleFactor = Math.min(scaleFactorWidth, scaleFactorHeight);

      // Calculate image dimensions
      const imgWidth = contentWidth * scaleFactor;
      const imgHeight = contentHeight * scaleFactor;

      // document
      //   .querySelector(".CircularProgressbar .changeClass")
      //   .classList.add("CircularProgressbar-path");

      pdf.addImage(dataUrl, "PNG", 0, 0, imgWidth, imgHeight);
      pdf.save("SkorProfile.pdf");

      // if (documentEle) documentEle.style.removeProperty("display");
    } catch (error) {
      // document
      //   .querySelector(".CircularProgressbar .changeClass")
      //   .classList.add("CircularProgressbar-path");

      console.error("Error capturing element:", error);
    }
  };

  const printDocumentSafari = async () => {
    const node = document.getElementById("divToPrint");
    // const documentEle = document.getElementById("downloadpdf");

    // if (documentEle)
    //   documentEle.style.setProperty("display", "none", "important");
    console.log();
    try {
      // document.querySelector(
      //   ".CircularProgressbar .CircularProgressbar-path"
      // ).classList = "changeClass";
      if (
        haveValue(
          document.querySelector(
            ".guage-main-upper .radial-gauge .doughnut .subArc:nth-child(3) path"
          )
        )
      )
        document.querySelector(
          ".guage-main-upper .radial-gauge .doughnut .subArc:nth-child(3) path"
        ).style.fill = "orange";

      const canvas = await html2canvas(node, { useCORS: true });
      const dataUrl = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const contentWidth = canvas.width;
      const contentHeight = canvas.height;

      // Calculate scale factors for width and height
      const scaleFactorWidth = pdfWidth / contentWidth;
      const scaleFactorHeight = pdfHeight / contentHeight;

      // Choose the smaller scale factor to fit content within A4 size
      const scaleFactor = Math.min(scaleFactorWidth, scaleFactorHeight);

      // Calculate image dimensions
      const imgWidth = contentWidth * scaleFactor;
      const imgHeight = contentHeight * scaleFactor;

      // document
      //   .querySelector(".CircularProgressbar .changeClass")
      //   .classList.add("CircularProgressbar-path");
      if (
        haveValue(
          document.querySelector(
            ".guage-main-upper .radial-gauge .doughnut .subArc:nth-child(3) path"
          )
        )
      )
        document.querySelector(
          ".guage-main-upper .radial-gauge .doughnut .subArc:nth-child(3) path"
        ).style.fill = "url('#grad1')";

      pdf.addImage(dataUrl, "PNG", 0, 0, imgWidth, imgHeight);
      pdf.save("SkorProfile.pdf");

      // if (documentEle) documentEle.style.removeProperty("display");
    } catch (error) {
      // document
      //   .querySelector(".CircularProgressbar .changeClass")
      //   .classList.add("CircularProgressbar-path");
      if (
        haveValue(
          document.querySelector(
            ".guage-main-upper .radial-gauge .doughnut .subArc:nth-child(3) path"
          )
        )
      )
        document.querySelector(
          ".guage-main-upper .radial-gauge .doughnut .subArc:nth-child(3) path"
        ).style.fill = "url('#grad1')";

      console.error("Error capturing element:", error);
    }
  };

  if (loading) return <Loader />;

  return (
    <>
      {haveValue(user) && (
        <>
          <div className="tabs-box-pattern-2">
            <div className="tabs-item-1 d-block">
              <div className="row">
                <div className="header-edit text-center space-custom d-flex items-center justify-content-between position-relative">
                  <div>
                    {" "}
                    <Link to="/home">
                      <img src={backicon} alt="backbtn" />
                    </Link>
                  </div>

                  <h3>{_t("tenantProfileAndProperty")}</h3>
                  <div></div>
                  <div
                    className="pdf-qrcode position-absolute"
                    style={{
                      right: "30px",
                      top: "50%",
                      transform: "translateY(-50%)",
                    }}
                  >
                    <div>
                      <button
                        className="btn btngreen downloadpdf"
                        id="downloadpdf"
                        onClick={printDocument}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                        >
                          <path
                            d="M4.5 0C3.25898 0 2.25 1.00898 2.25 2.25V5.625H4.5V2.25H12.4699L13.5 3.28008V5.625H15.75V3.28008C15.75 2.68242 15.5145 2.10938 15.0926 1.6875L14.0625 0.657422C13.6406 0.235547 13.0676 0 12.4699 0H4.5ZM13.5 12.375V15.75H4.5V12.375H13.5ZM15.75 13.5H16.875C17.4973 13.5 18 12.9973 18 12.375V9C18 7.75898 16.991 6.75 15.75 6.75H2.25C1.00898 6.75 0 7.75898 0 9V12.375C0 12.9973 0.502734 13.5 1.125 13.5H2.25V15.75C2.25 16.991 3.25898 18 4.5 18H13.5C14.741 18 15.75 16.991 15.75 15.75V13.5ZM15.1875 8.71875C15.4113 8.71875 15.6259 8.80764 15.7841 8.96588C15.9424 9.12411 16.0312 9.33872 16.0312 9.5625C16.0312 9.78628 15.9424 10.0009 15.7841 10.1591C15.6259 10.3174 15.4113 10.4062 15.1875 10.4062C14.9637 10.4062 14.7491 10.3174 14.5909 10.1591C14.4326 10.0009 14.3438 9.78628 14.3438 9.5625C14.3438 9.33872 14.4326 9.12411 14.5909 8.96588C14.7491 8.80764 14.9637 8.71875 15.1875 8.71875Z"
                            fill="#253837"
                          />
                        </svg>
                        {_t("downloadPDF")}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div id="divToPrint" className="row">
                <div className="tab-content" id="pills-tabContent">
                  <div
                    className="tab-pane fade show active"
                    id="pills-profile"
                    role="tabpanel"
                    aria-labelledby="pills-profile-tab"
                  >
                    <div className="edit-profile">
                      <div
                        className="tab-pane fade show active"
                        id="pills-home"
                        role="tabpanel"
                        aria-labelledby="pills-home-tab"
                      >
                        <div className="edit-profile">
                          <GeneratedReportComponent
                            properties={properties}
                            handleUnlinkProperty={() => {
                              console.log("Function Not needed here");
                            }}
                            fullinfo={fullInfo}
                            currentActiveAccordion={currentActiveAccordion}
                            setCurrentActiveAccordion={
                              setCurrentActiveAccordion
                            }
                            name={"hello"}
                            rent_from_income={null}
                            scoreProfile={
                              haveValue(user?.tenantid) ? user?.tenantid : user
                            }
                            defaultPropertyLink={[]}
                            propList={[]}
                            selectBtn={null}
                            handlePropSelect={() => {
                              console.log("Not needed here");
                            }}
                            handleLinkProperty={() => {
                              console.log("Not needed here");
                            }}
                            propertyLink={[]}
                            rentPercentage={rentPercentage}
                            setRentPercentage={setRentPercentage}
                            sharedProfileProp={{}}
                            definedRent={definedRent}
                            llCreated={llCreated}
                            originalUser={originalUser}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default GeneratedReport;
